<template>
  <div v-show="loading">
    <div class="p-d-flex p-ai-center p-my-3">
      <ProgressSpinner class="small" />
    </div>
  </div>
  <div v-show="!loading">
    <FormField title="Card Number" componentType="custom">
      <div ref="cardNumber" class="p-inputtext"></div>
    </FormField>

    <div class="card-footer">
      <FormField title="Expiration Date" componentType="custom" class="p-mb-0">
        <div ref="cardDate" class="p-inputtext"></div>
      </FormField>

      <FormField title="СVС/CVV" componentType="custom" class="p-mb-0">
        <div ref="cardCvc" class="p-inputtext"></div>
      </FormField>
    </div>
  </div>
</template>

<script setup>
import { useScriptTag } from '@vueuse/core'
import FormField from '../components/FormField';
import {onMounted, ref} from "vue";
import {usePaymentCard} from "../hooks/usePaymentCard";

const {getIntent} = usePaymentCard();

const loading = ref(true);

const loadScriptPromise = new Promise((resolve, reject) => {
  if (window.Stripe) {
    loading.value = false;
    return resolve();
  }

  useScriptTag('https://js.stripe.com/v3', (el) => {
      loading.value = false;
      resolve()
    },
  );
});

let stripe = null;
const cardNumber = ref();
const cardDate = ref();
const cardCvc = ref();
const cardNumberElement = ref();
const style = {
  base: {
    color: '#44486D',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontSmoothing: 'antialiased',

    ':focus': {
      color: '#44486D',
    },

    '::placeholder': {
      color: '#868C9B',
    },

    ':focus::placeholder': {
      color: '#868C9B',
    },
  },
  invalid: {
    color: '#44486D',
    ':focus': {
      color: '#44486D',
    },
    '::placeholder': {
      color: '#868C9B',
    },
  },
};

onMounted(async () => {
  await loadScriptPromise;

  stripe = window.Stripe(
    document.head.querySelector('meta[name=stripe_key]').content
  );

  const elements = stripe.elements({
    fonts: [
      {
        cssSrc: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap',
      }
    ]
  });

  cardNumberElement.value = elements.create('cardNumber', {style});
  cardNumberElement.value.mount(cardNumber.value);

  elements.create('cardExpiry', {style}).mount(cardDate.value);
  elements.create('cardCvc', {style}).mount(cardCvc.value);
})

const submit = async () => {
  if (stripe) {
    const {client_secret: clientSecret} = (await getIntent()).data;
    const {setupIntent, error} = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardNumberElement.value,
      },
    });

    if (error) {
      throw error;
    }

    return setupIntent;
  }

  return null;
}

defineExpose({
  submit
})

</script>

<style lang="scss" scoped>
@import "../assets/sass/theme_variables";


.card-footer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: toRem(10);
}

.p-inputtext {
  &.StripeElement--focus {
    border-color: #0F8BFD;
  }
  &.StripeElement--invalid {
    border-color: #FC6161;
  }
}

</style>
